module.exports = __webpack_public_path__ + "static/media/leave_sound.cfc8c964.mp3";